/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type InflationSurchargeFragment = {
  __typename: "InflationSurcharge"
  value?: number | null
}

export const InflationSurchargeFragmentDoc = gql`
  fragment InflationSurcharge on InflationSurcharge {
    value
  }
`
